
import createIconComponent from '../utils/createIconComponent';
import { SVG_MASTERCARD } from '../../../dist';
import React from 'react';
const MastercardIcon = createIconComponent({ content: SVG_MASTERCARD, height: 24, width: 34 });
MastercardIcon.displayName = 'MastercardIcon';
export default MastercardIcon;
